import React from 'react';
import { type FilterItemCheckbox } from '../../types';
import Grid2 from '@mui/material/Unstable_Grid2';
import { Typography } from '@mui/material';
import { Checkboxes } from 'mui-rff';

type FilterCheckboxFieldProps = {
  item: FilterItemCheckbox;
};

export const FilterCheckboxField = ({ item }: FilterCheckboxFieldProps) => {
  return (
    <Grid2 container direction="column">
      <Grid2>
        <Typography fontWeight={600} mb={1}>
          {item.label}
        </Typography>
      </Grid2>
      <Checkboxes name={item.name} data={item.options} />
    </Grid2>
  );
};
